
import '../Footer/footer.css'

const Footer = () => {
  return (
    <footer className='footer'>
        Copyright &#169; 2025 Shruti Gour. All right reserved.
    </footer>
  )
}

export default Footer
